import { render } from "./MixedTemplate.vue?vue&type=template&id=2e2ff8c7"
import script from "./MixedTemplate.vue?vue&type=script&lang=js"
export * from "./MixedTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/Clients/visiontrust/vision-trust-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__